import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  html, body, #root{
    margin: 0;
    height: 100%;
  }

  body {
    font-family: Work Sans;
    color: #232323;
    margin: 0;
  }
  h1 {
    text-align: center;
    padding: 32px 0;
    margin: 0;
    color: #000;
    // text-shadow: 1px 1px 1px #000;
  }

  h3 {
    margin: 0;
  }
`;
